/* RESPONSIBLE TEAM: team-standalone */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { attr } from '@ember-data/model';
import { type AllChannels } from 'embercom/lib/operator/custom-bots/constants';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { buildValidations } from 'ember-cp-validations';
import { validator } from 'ember-cp-validations';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type { HandoffToSalesforceOwnerIdByIntegration } from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-case';

const Validations = buildValidations({
  handoffToSalesforceOwnerId: [
    validator('handoff-to-salesforce-owner-id-valid', {
      dependentKeys: [
        'model.handoffToSalesforceOwnerId',
        'model.finStandaloneService.salesforcePlatform.salesforceSetupData',
        'model.finStandaloneService.salesforcePlatform.configurationData',
      ],
      messageKey:
        'operator.workflows.visual-builder.handoff-to-salesforce-team.missing-handoff-owner-id-error-message',
    }),
  ],
  handoffToSalesforceOwnerIdByIntegration: [
    validator('handoff-to-salesforce-owner-id-by-integration-valid', {
      dependentKeys: [
        'model.handoffToSalesforceOwnerId',
        'model.handoffToSalesforceOwnerIdByIntegration',
        'model.finStandaloneService.salesforcePlatform.salesforceSetupData',
        'model.finStandaloneService.salesforcePlatform.configurationData',
      ],
      messageKey:
        'operator.workflows.visual-builder.handoff-to-salesforce-team.missing-handoff-owner-id-error-message',
    }),
  ],
});

export default class HandoffToSalesforceTeam extends Step.extend(Validations) {
  @service declare finStandaloneService: FinStandaloneService;

  @attr('string') declare handoffToSalesforceOwnerId: string | null;
  @attr('array', { defaultValue: () => [] })
  declare handoffToSalesforceOwnerIdByIntegration: HandoffToSalesforceOwnerIdByIntegration;

  get supportedChannels(): Readonly<AllChannels[]> {
    return SUPPORTED_CHANNELS.handoffToSalesforceTeam;
  }

  static get supportedContexts(): TargetContext[] {
    return [TargetContext.Conversation];
  }

  static get isStepGroupEnding(): boolean {
    return true;
  }

  static get isStepTerminal(): boolean {
    return true;
  }

  static createNewStep(store: Store): HandoffToSalesforceTeam {
    return store.createRecord('operator/visual-builder/step/handoff-to-salesforce-team', {
      type: 'operator/visual-builder/step/handoff-to-salesforce-team',
    });
  }
}
